import { observer as mobxObserver } from 'mobx-react';
export function observer(component) {
    return mobxObserver(component);
}
